import HtmlParser from "react-html-parser"
import classNames from "classnames"
import { metadata, SVOD_END_DATE } from "lacinetek-common/src/metadata"

import { useTranslation } from "lib/i18n/translation"

import Image from "components/common/image"
import { getBestImage, TeaserLink } from "./block-header"
import { BlockText } from "./block-text"
import { BlockImageTitle } from "./block-image-title"

export const BlockHeaderSquare = ({ block, inOverlay }) => {
	const { c } = useTranslation()

	const endDate = metadata(block, SVOD_END_DATE)

	return (
		<section
			className={classNames(
				"no-fx",
				{
					"focus full has-splitted": inOverlay
				}
			)}
		>
			{
				(block.description && !inOverlay)
				&& HtmlParser(block.description)
			}
			<div className="splitted short">
				<figure className="full" style={{ aspectRatio: "400/220" }}>
					<TeaserLink block={block} mobile />
					<TeaserLink block={block} />
					<picture>
						<Image
							src={getBestImage(block)}
							alt={block.name}
						/>
					</picture>
				</figure>
				<div className="content">
					{
						endDate
						&& <span className="alert short large icon-clock">
							{`${c("until")} ${endDate}`}
						</span>
					}
					{/* <span className="h2">{???}</span> */}
					<BlockImageTitle block={block} inOverlay={inOverlay} />
					{
						!inOverlay
						&& <BlockText block={block} />
					}
				</div>
			</div>
		</section>
	)
}
